import React from 'react';

export  const CommunicationPossibleContext = React.createContext({
  isCommunicationPossible: true,
  setComm: () => {},
  toggleComm:() => {}
});

export default CommunicationPossibleContext;